import './error.css'
import Navbar from '../components/navbar'
import Footer from '../components/Footer'

function ErrorNa() {
    return (
        <>
            <Navbar />
            <div className="error-main">
                {/* <img src="/images/tgbs.webp" alt='Thakur Institute of Management Studies, Career Development & Research (TIMSCDR)'/> */}
                <div>Sorry, this page is under construction.
                    <br />We will be back soon.<br />
                    Click below to visit our Home Page...</div>
                <a href="/">Visit Now!</a>
            </div>
            <Footer />
        </>
    )
}

export default ErrorNa;